// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-shared-entries-permissions__body {
  display: flex;
  flex-direction: column;
  gap: var(--g-spacing-3);
}
.dialog-shared-entries-permissions__objects-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dialog-shared-entries-permissions__permissions-container {
  display: flex;
  flex-direction: column;
  gap: var(--g-spacing-4);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogSharedEntryPermissions/DialogSharedEntryPermissions.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAAR;AAGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAFR","sourcesContent":[".dialog-shared-entries-permissions__body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--g-spacing-3);\n}\n.dialog-shared-entries-permissions__objects-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.dialog-shared-entries-permissions__permissions-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--g-spacing-4);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
